/*!
 * Deep merge two or more objects together.
 * (c) 2019 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param   {Object}   objects  The objects to merge together
 * @returns {Object}            Merged values of defaults and options
 */
export default function deepMerge(objects, ignorePred) {
  // Setup merged object
  var newObj = {};

  // Merge the object into the newObj object
  var merge = function (obj = {}) {
    for (var prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        // If property is an object, merge properties
        if (Object.prototype.toString.call(obj[prop]) === "[object Object]") {
          if (ignorePred && ignorePred(obj[prop])) newObj[prop] = obj[prop];
          else newObj[prop] = deepMerge([newObj[prop], obj[prop]]);
        } else {
          newObj[prop] = obj[prop];
        }
      }
    }
  };

  for (var i = 0; i < objects.length; i++) {
    merge(objects[i]);
  }

  return newObj;
}

export function deepMergeWithArrayConcat(objects, ignorePred) {
  // Setup merged object
  var newObj = {};

  // Merge the object into the newObj object
  var merge = function (obj) {
    for (var prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        // If property is an object, merge properties
        if (Object.prototype.toString.call(obj[prop]) === "[object Object]") {
          if (ignorePred && ignorePred(obj[prop])) newObj[prop] = obj[prop];
          else
            newObj[prop] = deepMergeWithArrayConcat(
              [newObj[prop], obj[prop]],
              ignorePred
            );
          // Also concatenate arrays if both properties are an array
        } else if (Array.isArray(obj[prop]) && Array.isArray(newObj[prop])) {
          newObj[prop] = [...newObj[prop], ...obj[prop]];
        } else {
          newObj[prop] = obj[prop];
        }
      }
    }
  };

  for (var i = 0; i < objects.length; i++) {
    merge(objects[i]);
  }

  return newObj;
}
